<div id="vertical-menu" class="vertical-menu sidebar-body">
  <div class="sidebar-scroll-area">
    <ngx-simplebar class="sidebar-menu-simplebar" #simplebar>
      <div id="sidebar-menu">
        <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
          <li
            *ngFor="let module of modules$ | async"
            routerLinkActive="mm-active"
            [routerLinkActiveOptions]="
              module.link === '/' || module.link === '/family' ? { exact: true } : { exact: false }
            "
          >
            <a
              [routerLink]="[module.link]"
              class="side-nav-link-ref"
              routerLinkActive="active"
              [routerLinkActiveOptions]="
                module.link === '/' || module.link === '/family'
                  ? { exact: true }
                  : { exact: false }
              "
            >
              <i [class]="module.icon"></i>
              <span> {{ module.label }} </span>
            </a>
          </li>
        </ul>
      </div>
    </ngx-simplebar>
  </div>

  <div class="bottom-links" id="sidebar-menu-bottom">
    <ul class="metismenu list-unstyled">
      <li routerLinkActive="mm-active">
        <a
          [routerLink]="['/' + (role === 'COMMUNITY_RELATIVE' ? 'family' : ''), 'settings']"
          class="side-nav-link-ref"
          routerLinkActive="active"
        >
          <i class="bx bx-cog"></i>
          <span> Settings </span>
        </a>
      </li>
      <li>
        <a
          href="javascript: void(0);"
          class="side-nav-link-ref"
          routerLinkActive="active"
          (click)="logout()"
        >
          <i class="bx bx-exit"></i>
          <span> Logout </span>
        </a>
      </li>
    </ul>
  </div>
</div>
